var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"digit-guess-module"},[_c('div',{staticClass:"module",class:{
        step1: _vm.step === 1,
        step2: _vm.step === 2,
        step3: _vm.step >= 3
    },style:({zIndex: _vm.zIndex})},[_c('b-container',{staticClass:"module-container"},[_c('b-row',_vm._l((_vm.digits),function(digit){return _c('b-col',{key:digit.id,staticClass:"p-0"},[_c('digit-guess-state',{attrs:{"props":digit}})],1)}),1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }